module.exports = __webpack_public_path__ + "media/images/icons/config-6bb7e459e05c9feab5028d1975dc5d20.svg";